import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  coinlist: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "users",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getCoinList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getCoinList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      coinlist: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getCoinList.rejected, (state, action) => ({
      ...state,
      loading: false,
      coinlist: [],
      totalCount: 0,
    }));
  },
});

export default slice;
